<div class="display-flex full-height">
  <div class="images-container full-height relative">
    <span *ngFor="let item of array; let last = last;">
      {{ item }} <span *ngIf="!last">|</span>
    </span>
  </div>
</div>
